export const IDLE = 'loadingState/IDLE';
export const LOADING = 'loadingState/LOADING';
export const LOADED = 'loadingState/LOADED';
